import styled from "styled-components";

import { ReactComponent as ArrowDownIcon } from "assets/icons/new/arrow-down.svg";
import { ReactComponent as BlankIcon } from "assets/icons/new/blank.svg";
import { ReactComponent as CalendarIcon } from "assets/icons/new/calendar.svg";
import { ReactComponent as CheckIcon } from "assets/icons/new/check.svg";
import { ReactComponent as ClientIcon } from "assets/icons/new/client.svg";
import { ReactComponent as ClipIcon } from "assets/icons/new/clip.svg";
import { ReactComponent as CloseLargeIcon } from "assets/icons/new/close-large.svg";
import { ReactComponent as CloseIcon } from "assets/icons/new/close.svg";
import { ReactComponent as CouponIcon } from "assets/icons/new/coupon.svg";
import { ReactComponent as CopyIcon } from "assets/icons/new/copy.svg";
import { ReactComponent as CustomerIcon } from "assets/icons/new/customer.svg";
import { ReactComponent as DashboardIcon } from "assets/icons/new/dashboard.svg";
import { ReactComponent as DeleteIcon } from "assets/icons/new/delete.svg";
import { ReactComponent as DeleteBoldIcon } from "assets/icons/new/delete-bold.svg";
import { ReactComponent as DraggableIcon } from "assets/icons/new/draggable.svg";
import { ReactComponent as EditIcon } from "assets/icons/new/edit.svg";
import { ReactComponent as FixedIcon } from "assets/icons/new/fixed.svg";
import { ReactComponent as FoldIcon } from "assets/icons/new/fold.svg";
import { ReactComponent as HomeIcon } from "assets/icons/new/home.svg";
import { ReactComponent as InfoIcon } from "assets/icons/new/info.svg";
import { ReactComponent as LogoutIcon } from "assets/icons/new/logout.svg";
import { ReactComponent as ManagementIcon } from "assets/icons/new/management.svg";
import { ReactComponent as MinusIcon } from "assets/icons/new/minus.svg";
import { ReactComponent as MoreIcon } from "assets/icons/new/more.svg";
import { ReactComponent as MoveIcon } from "assets/icons/new/move.svg";
import { ReactComponent as NotificationIcon } from "assets/icons/new/notification.svg";
import { ReactComponent as NotificationNewIcon } from "assets/icons/new/notification-new.svg";
import { ReactComponent as PlayIcon } from "assets/icons/new/play.svg";
import { ReactComponent as PlayerIcon } from "assets/icons/new/player.svg";
import { ReactComponent as PlusIcon } from "assets/icons/new/plus.svg";
import { ReactComponent as PreviousIcon } from "assets/icons/new/previous.svg";
import { ReactComponent as PrintIcon } from "assets/icons/new/print.svg";
import { ReactComponent as ReservationIcon } from "assets/icons/new/reservation.svg";
import { ReactComponent as ResizeIcon } from "assets/icons/new/resize.svg";
import { ReactComponent as SalesIcon } from "assets/icons/new/sales.svg";
import { ReactComponent as SearchIcon } from "assets/icons/new/search.svg";
import { ReactComponent as Settings16Icon } from "assets/icons/new/settings-16.svg";
import { ReactComponent as Settings24Icon } from "assets/icons/new/settings-24.svg";
import { ReactComponent as SortUpIcon } from "assets/icons/new/sort-up.svg";
import { ReactComponent as SortDownIcon } from "assets/icons/new/sort-down.svg";
import { ReactComponent as SortDefaultIcon } from "assets/icons/new/sort.svg";
import { ReactComponent as StaffIcon } from "assets/icons/new/staff.svg";
import { ReactComponent as TimeIcon } from "assets/icons/new/time.svg";
import { ReactComponent as ViewIcon } from "assets/icons/new/view.svg";
import { ReactComponent as ViewOffIcon } from "assets/icons/new/view-off.svg";
import { ReactComponent as WarningIcon } from "assets/icons/new/warning.svg";
import { ReactComponent as ExpandIcon } from "assets/icons/new/expand.svg";
import { ReactComponent as CollapseIcon } from "assets/icons/new/collapse.svg";
import { defaultAnimationDuration } from "common/const/const";

export const IconWrapper = styled.span`
  width: ${({ width, size }) => width ?? size ?? "1.5rem"};
  height: ${({ height, size }) => height ?? size ?? "1.5rem"};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  line-height: 0;
  vertical-align: middle;

  transition:
    width ${defaultAnimationDuration} ease,
    height ${defaultAnimationDuration} ease;

  cursor: ${({ onClick, disabled }) =>
    disabled ? "not-allowed" : onClick ? "pointer" : "inherit"};

  &:active {
    opacity: 0.8;
  }

  svg {
    width: 100%;
    height: 100%;
    display: block;
  }
`;

const ArrowLeftIcon = (props) => (
  <ArrowDownIcon {...props} style={{ transform: "rotate(90deg)" }} />
);
const ArrowRightIcon = (props) => (
  <ArrowDownIcon {...props} style={{ transform: "rotate(270deg)" }} />
);
const ArrowUpIcon = (props) => (
  <ArrowDownIcon {...props} style={{ transform: "rotate(180deg)" }} />
);

const NextIcon = (props) => (
  <PreviousIcon {...props} style={{ transform: "rotate(180deg)" }} />
);

const SortIcon = ({ sortDirection, ...props }) => {
  if (sortDirection === "asc") return <SortUpIcon {...props} />;
  if (sortDirection === "desc") return <SortDownIcon {...props} />;
  return <SortDefaultIcon {...props} />;
};

export {
  ArrowDownIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  ArrowUpIcon,
  BlankIcon,
  CalendarIcon,
  CheckIcon,
  ClientIcon,
  ClipIcon,
  CloseLargeIcon,
  CloseIcon,
  CouponIcon,
  CopyIcon,
  CustomerIcon,
  DashboardIcon,
  DeleteIcon,
  DeleteBoldIcon,
  DraggableIcon,
  EditIcon,
  FixedIcon,
  FoldIcon,
  HomeIcon,
  InfoIcon,
  LogoutIcon,
  ManagementIcon,
  MinusIcon,
  MoreIcon,
  MoveIcon,
  NotificationIcon,
  NotificationNewIcon,
  PlayIcon,
  PlayerIcon,
  PlusIcon,
  PreviousIcon,
  PrintIcon,
  NextIcon,
  ReservationIcon,
  ResizeIcon,
  SalesIcon,
  SearchIcon,
  Settings16Icon,
  Settings24Icon,
  SortIcon,
  StaffIcon,
  TimeIcon,
  ViewIcon,
  ViewOffIcon,
  WarningIcon,
  ExpandIcon,
  CollapseIcon,
};
